import {AxiosInstance} from "axios";

const RcsResource = (client: AxiosInstance) => {
    return {
        /**
         * Get RCS device capabilities for a phone number.
         * @param phone
         */
        async deviceCapabilities(phone: string): Promise<{is_capable: boolean}> {
            return client.get(`/rcs/device-capabilities`, {
                params: {phone}
            }).then(response => response.data.data);
        }
    };
};

export default RcsResource;
